import React, { Fragment } from 'react'
import { Box, styled } from '@mui/material'
import { Tooltip } from 'packages/eid-ui'
import ItemTypeSummaryDetailsTooltip from './ItemTypeSummaryDetailsTooltip'
import { Icon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'
import TextFormatter from '../TextFormatter'
import classNames from 'classnames'

const AttributeBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '0.2rem 1rem 0.2rem 0',
    fontSize: '1.3rem !important',
    color: '#5d6870 !important',
    '& > svg': {
        marginBottom: '0.1rem',
    },
}))

const IconContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: '0.6rem',
    fontWeight: 'bold',
}))

const IconContainerDefault = styled(IconContainer)(({ theme }) => ({
    '&:hover': {
        '& > div': {
            borderColor: '#cdcdd1',
        },
    },
}))

const IconContainerResourceType = styled(IconContainer)(({ theme }) => ({
    '&:hover': {
        '& > svg': {
            color: '#000000',
        },
    },
}))

const TotalCount = styled(Box)(({ theme }) => ({
    fontWeight: 'bold',
    marginRight: '0.6rem',
}))

const ItemTypeCount = ({ requestId, itemTypeCount }) => {
    const { t } = useTranslation()

    return (
        <Fragment>
            {itemTypeCount.map((itemType) => (
                <AttributeBox key={itemType.itemTypeId}>
                    <Tooltip
                        key={itemType.itemTypeId}
                        title={
                            <ItemTypeSummaryDetailsTooltip
                                requestId={requestId}
                                itemTypeId={itemType.itemTypeId}
                            />
                        }
                        enterDelay={800}
                    >
                        {itemType.resourceType === 'Unknown' ? (
                            <IconContainerDefault component="span">
                                <Box
                                    sx={{
                                        height: '1.6rem',
                                        width: '1.6rem',
                                        border: '0.4rem solid #d8d8dd',
                                        bgcolor: 'transparent',
                                        borderRadius: '50%',
                                    }}
                                />
                            </IconContainerDefault>
                        ) : (
                            <IconContainerResourceType component="span">
                                <Icon
                                    name={itemType.resourceType}
                                    color="#919193"
                                />
                            </IconContainerResourceType>
                        )}
                    </Tooltip>
                    <TotalCount component="span">
                        {itemType.totalCount}
                    </TotalCount>

                    {itemType.resourceType !== 'Unknown' ? (
                        t(`Common_${itemType.resourceType}`)
                    ) : (
                        <Box component="span">
                            <TextFormatter
                                value={itemType.categoryName}
                                maxCharacters={40}
                                style={{
                                    fontSize: '1.3rem',
                                }}
                            />
                        </Box>
                    )}
                </AttributeBox>
            ))}
        </Fragment>
    )
}

export default ItemTypeCount
